<script lang="ts">import { Button } from "@infinitro/button";
import { appMode, AppMode, FeatureSet, stateFeatureSet } from "@infinitro/config";
import { t } from "@infinitro/content";
import { onMount } from "svelte";
import { get } from "svelte/store";
import { fade, fly } from "svelte/transition";
import { cookieConsent, setCookieConsent } from "./cookie-store";
export let position = "bottom";
export let customClass = "";
export let autoShow = true;
let visible = false;
let hasConsent = false;
let shouldShowModal = false;
onMount(() => {
	const currentFeatureSet = get(stateFeatureSet);
	const isPreviewFeature = currentFeatureSet === FeatureSet.Preview;
	shouldShowModal = isPreviewFeature;
	if (!shouldShowModal) {
		return;
	}
	hasConsent = $cookieConsent;
	if (autoShow && !hasConsent) {
		setTimeout(() => {
			visible = true;
		}, 1e3);
	}
});
function handleAccept() {
	setCookieConsent(true);
	visible = false;
}
export function show() {
	visible = true;
}
export function hide() {
	visible = false;
}
$: positionClass = position === "bottom" ? "bottom-6" : "top-6";
</script>

{#if shouldShowModal && visible && !hasConsent}
	<div
		class="cookies-modal fixed {positionClass} left-1/2 -translate-x-1/2 w-[calc(100%-16px)] max-w-[448px] z-[9999] {customClass}"
		transition:fly={{ y: position === 'bottom' ? 100 : -100, duration: 400 }}
	>
		<div class="modal-content flex items-center gap-3 p-4 rounded-[24px] border-[1.5px] shadow-2xl">
			<div class="flex-shrink-0">
				<div class="text-[24px]" aria-label="Cookie">🍪</div>
			</div>

			<div class="flex-1 min-w-0">
				<p class="text-white text-[14px] leading-relaxed font-medium whitespace-normal break-words">
					{$t('cookies_modal_text')}
				</p>
			</div>

			<div class="flex-shrink-0">
				<Button
					text={$t('accept')}
					onClick={handleAccept}
					variant="primary"
					size="medium"
					className="!px-8 !py-3 !min-w-[120px] !rounded-full !font-semibold !text-sm md:!text-base whitespace-nowrap"
					uppercase={true}
				/>
			</div>
		</div>
	</div>
{/if}

<style>
	.modal-content {
		background: linear-gradient(
			to bottom,
			var(--color-background-700, #1a1f3a),
			var(--color-background-700, #0f1629)
		);
		border-color: var(--color-background-300, rgba(255, 255, 255, 0.15));
		box-shadow:
			0 0 0 2px var(--color-neutral-900, rgba(0, 0, 0, 0.5)),
			0 25px 50px -12px rgba(0, 0, 0, 0.5);
	}

	:global(body) {
		overflow-x: hidden;
	}
</style>
